import trapFocus from '@/entrypoints/helpers/trapFocus';
import pauseAllMedia from '@/entrypoints/helpers/pauseAllMedia';

export default class ModalDialog extends HTMLElement {
    constructor() {
        super();
        this.querySelector('[id^="ModalClose"]').addEventListener(
            'click',
            this.hide.bind(this)
        );
        this.addEventListener('keyup', (event) => {
            if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        if (this.classList.contains('media-modal')) {
            this.addEventListener('pointerup', (event) => {
                if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
            });
        } else if (this.querySelector('.js-modal-overlay')) {
            this.querySelector('.js-modal-overlay').addEventListener('pointerup', (event) => {
                if (event.pointerType === 'mouse') this.hide();
            });
        } else {
            this.addEventListener('click', (event) => {
                if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
            });
        }
    }

    show(opener) {
        this.openedBy = opener;
        const popup = this.querySelector('.template-popup');
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        this.classList.add('is-active');
        if (popup) popup.loadContent();
        trapFocus.init(this, this.querySelector('[role="dialog"]'));
        pauseAllMedia.init();
        const initialFocus = this.querySelector('[data-initial-focus]');
        if (initialFocus) {
            initialFocus.focus();
        }
    }

    hide() {
        document.body.classList.remove('overflow-hidden');
        this.removeAttribute('open');
        this.classList.remove('is-active');
        if (this.openedBy) {
            this.openedBy.classList.remove('is-active');
            trapFocus.remove(this.openedBy);
        }
        pauseAllMedia.init();
    }
}

if (!customElements.get('modal-dialog')) {
    customElements.define('modal-dialog', ModalDialog);
}
